module.exports = __webpack_public_path__ + "img/icon-concierge.47839f43.svg";